import { handleErrors } from '../utils/_handleErrors';

class mNpsDiduenjoy extends HTMLDivElement {
    constructor() {
        super();
        this.diduenjoyDataUrl = this.dataset.getDiduenjoyUrl;

        this.setupParams();
        if (!('globalE' in this.dataset)) {
            this.setupScript();
        }

        this.onGlobalECheckoutConfirmation = this.onGlobalECheckoutConfirmation.bind(this);
    }

    connectedCallback() {
        if ('globalE' in this.dataset) {
            document.addEventListener('checkout:confirmation', this.onGlobalECheckoutConfirmation);
        }
    }

    disconnectedCallback() {
        document.removeEventListener('checkout:confirmation', this.onGlobalECheckoutConfirmation);
    }

    /**
     * Setup inital diduenjoy parameters
     */
    setupParams() {
        if (!window._diduenjoy) {
            window._diduenjoy = {};
        }
        if (!window._diduenjoy.params) {
            window._diduenjoy.params = {};
        }

        if ('json' in this.dataset) {
            const diduenjoyData = JSON.parse(this.dataset.json);
            diduenjoyData.params = Object.assign(window._diduenjoy.params, diduenjoyData.params);
            window._diduenjoy = Object.assign(window._diduenjoy, diduenjoyData);
        }
    }

    /**
     * Add the diduenjoy script into the main DOM and open the popup once ready
     */
    setupScript() {
        // Add diduenjoy script to DOM
        const popupId = 'diduenjoypopup';
        if (document.getElementById(popupId)) {
            return;
        }
        window.addEventListener('DiduenjoySurveyLoaded', () => {
            window.Diduenjoy.surveyPopup();
        }, { once: true });
        this.scriptEl = document.createElement('script');
        this.scriptEl.id = popupId;
        this.scriptEl.src = `${document.location.protocol === 'https:' ? 'https' : 'http'}://cdn.diduenjoy.${window._diduenjoy.domain}/libs/due-popup.min.js`;
        const firstScriptEl = document.getElementsByTagName('script')[0];
        firstScriptEl.before(this.scriptEl);
    }

    /**
     * Update diduenjoy parameters from Global-E data and start script after order confirmation
     * @param {CustomEvent} event - Event dispatch by the Global-E script (geScriptLoader.js)
     */
    onGlobalECheckoutConfirmation(event) {
        const geData = event.detail;
        const geDetails = geData?.details || {};
        const gePaymentMethod = geDetails.OrderPaymentMethods && geDetails.OrderPaymentMethods[0];
        const newParams = {
            order_id: geData.MerchantOrderId ?? null,
            ref_mail: geDetails.CustomerDetails?.BillingAddress?.BillingEmail ?? null,
            transaction_amount: gePaymentMethod?.PaidAmountInCustomerCurrency ?? null,
            transaction_date: (new Date()).toISOString(),
            guest_account: !geDetails.CustomerDetails?.MerchantUserId,
            customer_id: geDetails.CustomerDetails?.MerchantUserId ?? null,
            payment_method: gePaymentMethod?.PaymentMethodName?.toLowerCase() ?? null,
        };
        window._diduenjoy.params = Object.assign(window._diduenjoy.params, newParams);

        this.fetchDiduenjoyData(window._diduenjoy.params.order_id, window._diduenjoy.params.ref_mail, 10, 5000)
            .then((data) => {
                window._diduenjoy = Object.assign(window._diduenjoy, data);
            })
            .finally(() => {
                this.setupScript();
            });
    }

    fetchDiduenjoyData(orderId, customerEmail, maxRetry, retryDelay, attemptCount = 1) {
        const fetchDiduenjoyTimestamp = Date.now();
        const url = new URL(this.diduenjoyDataUrl);
        url.searchParams.set('orderid', orderId);
        url.searchParams.set('customeremail', customerEmail);
        return fetch(url, { method: 'GET' })
            .then(handleErrors)
            .then((response) => response.json())
            .then((data) => {
                if (!data.success) {
                    throw new Error(data.message ?? 'Unknown error');
                }
                if (!data?.diduenjoy?.params?.customer_id) {
                    throw new Error('No customer_id found');
                }
                return Promise.resolve(data);
            })
            .catch((error) => {
                if (attemptCount >= maxRetry) {
                    throw new Error(
                        `Failed to fetch Diduenjoy data after ${attemptCount} attempt(s)`,
                        { cause: error },
                    );
                }
                const nowTimestamp = Date.now();
                const delay = Math.max(0, retryDelay - (nowTimestamp - fetchDiduenjoyTimestamp));
                return new Promise((resolve) => { setTimeout(resolve, delay); })
                    .then(() => this.fetchDiduenjoyData(
                        orderId,
                        customerEmail,
                        maxRetry,
                        retryDelay,
                        attemptCount + 1,
                    ));
            });
    }
}

customElements.define('m-nps-diduenjoy', mNpsDiduenjoy, {
    extends: 'div',
});
